import React, { Component } from "react";
import '../assets/styles/Navigation.scss';
import bookdoc_logo from '../assets/images/bookdoc-logo.svg';
import { Navbar, Nav,NavDropdown, Dropdown, DropdownButton } from 'react-bootstrap';
import { userService } from '../services/user';
import { SignInModal } from "./SignInModal";
import { SignUpModal } from "./SignUpModal";
import { ChangePwModal } from "./ChangePwModal";
import marketplace_btn from '../assets/images/bookdoc-marketplace-btn.png';
import premium_btn from '../assets/images/bookdoc-premium-btn.png';
import premium_plus_btn from '../assets/images/bookdoc-premium-plus-btn.png';
// import mobile_premium_btn from '../assets/images/mobile-bookdoc-premium-btn.png';
// import mobile_premium_plus_btn from '../assets/images/mobile-bookdoc-premium-plus-btn.png';

class Navigation extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isOpen: false,
        name: null,
        showActiv: false,
        showAboutUs: false,
        showServices: false,
        showNewsroom: false,
        showCareers: false,
        showSignInModal: false,
        showSignUpModal: false,
        showChangePwModal: false
      };

      this.handleSignInModal = this.handleSignInModal.bind(this);
      this.handleSignUpModal = this.handleSignUpModal.bind(this);
      this.handleChangePwModal = this.handleChangePwModal.bind(this);
    }

    navLists = [{
        title: 'What We Offer',
        path: '/#',
        slug: 'what_we_offer',
        subs: [
          {
            title: 'Healthcare',
            slug: 'healthcare',
            path: '/#',
            submenu: [
              {
                title: 'Search And Book',
                path: '/search-book'
              },{
                title: 'E-MC',
                path: '/web/e-mc'
              },{
                title: 'Teleconsult',
                path: '/what-we-offer/teleconsult'
              },{
                title: 'Health Management',
                path: '/what-we-offer/health-management'
              }

            ]
          },{
            title: 'Wellness',
            slug: 'wellness',
            path: '/#',
            submenu: [
              {
                title: 'Activ',
                path: '/what-we-offer/activ'
              },{
                title: 'Food Log',
                path: '/what-we-offer/food-log'
              },{
                title: 'Challenges',
                path: '/what-we-offer/challenges'
              },{
                title: 'Mental Health',
                path: '/what-we-offer/mental-health'
              },{
                title: 'HRDC Claimable',
                path: '/hrdc-claimable'
              },{
                title: 'Wellness Events',
                path: '/who-we-serve/corporates/wellness-events'
              }
            ]
          },
        ]
      },{
        title: 'Who We Serve',
        path: '/#',
        slug: 'who_we_serve',
        subs: [
          {
            title: 'Corporates',
            path: '/who-we-serve/corporates'
          },{
            title: 'Healthcare Providers',
            path: '/who-we-serve/healthcare-providers'
          },{
            title: 'Individuals',
            path: '/who-we-serve/individuals'
          }
        ]
      },{
        title: 'About',
        path: '/#',
        slug: 'about',
        subs: [{
          title: 'Our Company',
          path: '/about/our-company'
        },{
          title: 'Our People',
          path: '/about/our-people'
        },{
          title: 'Newsroom',
          path: '/newsroom'
        }]
      },{
        title: 'Articles',
        path: '/articles'
      },{
        title: 'Pricing',
        path: '/pricing'
      }
    ]

    navListsMobile = this.navLists;
    // navListsMobile = this.navLists.concat([{
    //   title: 'Expert Columns',
    //   path: '/search-book/expert-column'
    // },{
    //   title: 'Testimonials',
    //   path: '/testimonials'
    // },{
    //   title: 'FAQs',
    //   path: '/faqs'
    // },{
    //   title: 'Download BookDoc App',
    //   path: '/download-bookdoc-app'
    // },{
    //   title: 'Contact Us',
    //   path: '/contact-us'
    // }]);

    openModal = () => this.setState({ isOpen: true });
    closeModal = () => this.setState({ isOpen: false });

    closeModal = () => this.setState({ isOpen: false });

    showActivDropdown = () => this.setState({ showActiv: true});
    hideActivDropdown = () => this.setState({ showActiv: false});
    showAboutUsDropdown = () => this.setState({ showAboutUs: true});
    hideAboutUsDropdown = () => this.setState({ showAboutUs: false});
    showServicesDropdown = () => this.setState({ showServices: true});
    hideServicesDropdown = () => this.setState({ showServices: false});
    showNewsroomDropdown = () => this.setState({ showNewsroom: true});
    hideNewsroomDropdown = () => this.setState({ showNewsroom: false});
    showCareersDropdown = () => this.setState({ showCareers: true});
    hideCareersDropdown = () => this.setState({ showCareers: false});

    activClick = (path) => {
      if(path !== '/#'){
        window.location.href = `${process.env.REACT_APP_MAIN_SITE_URL}${path}`;
      }
    }

    onMouse = (name, is_show) => {
      switch(name) {
        case 'who_we_serve':
          is_show ? this.showActivDropdown() : this.hideActivDropdown(); 
          break;
        case 'about':
          is_show ? this.showAboutUsDropdown() : this.hideAboutUsDropdown(); 
          break;
        case 'what_we_offer':
          is_show ? this.showServicesDropdown() : this.hideServicesDropdown(); 
          break;
        default:
          return false;
      }
    }

    getState = (name) => {
      switch(name) {
        case 'who_we_serve':
          return this.state.showActiv;
        case 'about':
          return this.state.showAboutUs;
        case 'what_we_offer':
          return this.state.showServices;
        default:
          return false;
      }
    }

    logout = (e) => {
      userService.logout(false);

      if(this.props.location.state )
        window.location.reload();
      else
        this.props.history.push({ pathname: "/search-book" });
    }

    handleSignInModal = (isOpen) => this.setState({ showSignInModal: isOpen });
    handleSignUpModal = (isOpen) => this.setState({ showSignUpModal: isOpen });
    handleChangePwModal = (isOpen) => this.setState({ showChangePwModal: isOpen });
    handleSwitchSignInModal  = (isOpen) => this.setState({ showSignInModal: isOpen, showSignUpModal: !isOpen  });
    handleSwitchSignUpModal  = (isOpen) => this.setState({ showSignInModal: !isOpen, showSignUpModal: isOpen });
    handleSwitchChangePwModal  = (isOpen) => this.setState({ showSignInModal: !isOpen, showChangePwModal: isOpen });

    render() {
    return (
        <div>
          <div className="top-banner">
            <div className="top-banner-content">
              <div className="top-banner-socials">
                  <a className="btn social-btn" href="https://www.facebook.com/BookDoc4u/" target="_blank" rel="noreferrer"><i className="fa fa-facebook" aria-hidden="true"></i> </a>
                  <a className="btn social-btn" href="https://twitter.com/bookdoc?lang=en" target="_blank" rel="noreferrer"><i className="fa-brands fa-x-twitter social-icon"></i> </a>
                  <a className="btn social-btn" href="https://www.instagram.com/bookdoc4u/?hl=en" target="_blank" rel="noreferrer"><i className="fa fa-instagram" aria-hidden="true"></i> </a>
                  <a className="btn social-btn" href="https://www.youtube.com/channel/UCzXEKbAQejcj1Y8uFiuVipQ" target="_blank" rel="noreferrer"><i className="fa fa-youtube-play" aria-hidden="true"></i> </a>
                  <a className="btn social-btn" href="https://www.linkedin.com/organization-guest/company/bookdoc?challengeId=AQFvAzT0EafU_wAAAXN5o_ENDOZqkhQ09s5xCPbn5CnqiJ2hopjBXkbHsexXLCHG0RDLchO9Dt7RhiR2I0-39fGaPzwQPZInrg&amp;submissionId=f5a4fba7-d542-2416-2cb8-8c32c643cf00" target="_blank" rel="noreferrer"><i className="fa fa-linkedin" aria-hidden="true"></i> </a>
                  <a className="btn social-btn" href="https://www.tiktok.com/@bookdoc4u" target="_blank" rel="noreferrer"><i className="fa-brands fa-tiktok"></i> </a>
              </div>
              <div className="top-banner-contacts">
                <a href="http://wa.me/60126442362" className="top-banner-whatsapp top-banner-contacts-item">
                  <i className="fa fa-whatsapp" aria-hidden="true"></i>WhatsApp Chat Only
                </a>
                <a href="tel:1300-88-2362" className="top-banner-phone top-banner-contacts-item">
                  <i className="fa fa-phone phone-icon" aria-hidden="true"></i>1300-88-2362
                </a>
                <a href="mailto:care@bookdoc.com" className="top-banner-email top-banner-contacts-item">
                  <i className="fa fa-envelope envelope-icon" aria-hidden="true"></i>care@bookdoc.com
                </a>
              </div>
            </div>
          </div>

          <Navbar collapseOnSelect expand="lg" variant="light">
            <Navbar.Brand href={`${process.env.REACT_APP_MAIN_SITE_URL}`} className="img-fluid">
              <img src={bookdoc_logo} className="header-logo" alt="logo" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <div className="overlay-navbar"></div>
              <div className="mobile-nav-links-container">
                <Nav className="mr-auto desktop-v">
                  {this.navLists.map((n,i) => {
                    if(n.subs && n.subs.length > 0 && n.slug === 'what_we_offer'){
                      return (
                        <NavDropdown title={
                          <div className="nav-title">
                            {n.title}
                            <i className="fa fa-angle-down dropdown-icon" aria-hidden="true"></i>
                          </div>
                        }
                        className={`what-we-offer collasible-nav-dropdown ${[n.slug].includes('what_we_offer') ? "active" : ""}`}
                        onClick={() => this.activClick(n.path)}
                        show={this.getState(n.slug)} 
                        onMouseEnter={() => this.onMouse(n.slug, true)} 
                        onMouseLeave={() => this.onMouse(n.slug, false)} 
                        key={`nav-dropdown-${i}`}
                        >
                          
                          {n.subs.map((m, ind) => {
                            return (
                              <div className="custom-menu-col" key={`custom-menu-${ind}`}>
                                <div className="custom-menu-title">{m.title}</div>
                                {m.submenu.map((s, ind) => {
                                return (
                                  <NavDropdown.Item 
                                  href={s.title === 'Marketplace' ? s.path : `${process.env.REACT_APP_MAIN_SITE_URL}${s.path}`} 
                                  key={`nav-dropdown-item-${ind}`}
                                  className={`${window.location.pathname.includes(s.path) ? "active" : ""}`}
                                  >
                                    {s.title}
                                  </NavDropdown.Item>
                                )
                              })}
                              </div>
                            )
                          })}
                          <div className="custom-menu-col premium-menu">
                              <div className="custom-menu-title">Premium Programme</div>
                              <a href={`${process.env.REACT_APP_MAIN_SITE_URL}/premium-programme`} rel="noreferrer">
                                <img src={premium_btn} className="premium-logo" alt="premium programme" />
                              </a>
                              <a href={`${process.env.REACT_APP_MAIN_SITE_URL}/premium-plus-programme`} rel="noreferrer">
                                <img src={premium_plus_btn} className="premium-logo" alt="premium plus programme" />
                              </a>
                              <div className="custom-menu-title">Explore Our Marketplace!</div>
                              <a href="https://shop.bookdoc.com/" rel="noreferrer">
                                <img src={marketplace_btn} className="premium-logo" alt="marketplace" />
                              </a>
                            </div>
                        </NavDropdown>
                      ) 
                    }else if(n.subs && n.subs.length > 0){
                      return (
                        <NavDropdown title={
                          <div className="nav-title">
                            {n.title}
                            <i className="fa fa-angle-down dropdown-icon" aria-hidden="true"></i>
                          </div>
                        }
                        className={`collasible-nav-dropdown ${[n.path].includes('/services') ? "active" : ""}`}
                        onClick={() => this.activClick(n.path)}
                        show={this.getState(n.slug)} 
                        onMouseEnter={() => this.onMouse(n.slug, true)} 
                        onMouseLeave={() => this.onMouse(n.slug, false)} 
                        key={`nav-dropdown-${i}`}
                        >
                          {n.subs.map((s, ind) => {
                            return <NavDropdown.Item 
                            href={s.title === 'Marketplace' ? s.path : `${process.env.REACT_APP_MAIN_SITE_URL}${s.path}`} 
                            key={`nav-dropdown-item-${ind}`}
                            className={`${window.location.pathname.includes(s.path) ? "active" : ""}`}
                            >
                              {s.title}
                            </NavDropdown.Item>;
                          })}
                        </NavDropdown>
                      )
                    }else{
                      return (
                        <div className="nav-item" key={`nav-item-${i}`}><Nav.Link href={`${process.env.REACT_APP_MAIN_SITE_URL}${n.path}`}>{n.title}</Nav.Link></div>
                      )
                    }
                  })}
                  {(() => {
                    if(userService.getUser()){
                    return (
                        <DropdownButton className="more-btn nav-item" variant="danger" title={`${userService.getUser().first_name}`}>
                          <Dropdown.Item href='/search-book/upcoming-appointment'>Upcoming Appointments</Dropdown.Item>
                          <Dropdown.Item href='/search-book/past-appointment'>Past Appointments</Dropdown.Item>
                          <Dropdown.Item href='/search-book/favourites'>Favourites</Dropdown.Item>
                          <Dropdown.Item href="/search-book/settings">Settings</Dropdown.Item>
                          <Dropdown.Item href="#" onClick={this.logout}>Sign out</Dropdown.Item>
                        </DropdownButton>
                    );
                    }else{
                      return <div className="nav-item"><button type="button" className="btn btn-danger login-btn" onClick={() => this.handleSignInModal(true)}><span className="sign-in-text">Sign In</span></button></div>;
                    }
                  })()}
                </Nav>

                <Nav className="mr-auto mobile-v">
                  <div className="mobile-nav-close">
                    <Navbar.Toggle aria-controls="basic-navbar-nav">
                      <i className="fa fa-times" aria-hidden="true"></i>
                    </Navbar.Toggle>
                  </div>

                  {this.navListsMobile.map((n,i) => {
                    if(n.subs && n.subs.length > 0 && n.slug === 'what_we_offer'){
                      return (
                        <NavDropdown title={<span className="nav-title">{n.title} <i className="fa fa-chevron-down icon-rotates icon-rotates-180" aria-hidden="true"></i></span>}  
                        id="what-we-offer-menu"
                        className={`collasible-nav-dropdown what-we-offer-menu ${[n.slug].includes('what_we_offer') ? "active" : ""}`}
                        key={`nav-dropdown-${i}`}
                        >
                          {n.subs.map((s, ind) => {
                            return (<NavDropdown title={<span className="nav-title">{s.title} <i className="fa fa-plus icon-rotates-sub" aria-hidden="true"></i></span>}  
                            className={`collasible-nav-dropdown-sub mobile-sub-dropdown ${(s.slug === 'healthcare') ? "active" : ""}`}
                            key={`nav-dropdown-sub-${ind}`}
                            >
                              {s.submenu.map((m, ind) => {
                                return (<NavDropdown.Item 
                                href={m.title === 'Marketplace' ? m.path : `${process.env.REACT_APP_MAIN_SITE_URL}${m.path}`} 
                                key={`nav-dropdown-item-sub-${ind}`}
                                className={`${(m.path.includes('/search-book') && !['/search-book/expert-column'].includes(window.location.pathname)) ? 'active' : ''}`}
                                >
                                  {m.title}
                                </NavDropdown.Item>);
                              })}
                            </NavDropdown>)
                          })}
                          <NavDropdown title={<span className="nav-title">Premium Programme <i className="fa fa-plus icon-rotates-sub" aria-hidden="true"></i></span>}  
                            className={`collasible-nav-dropdown-sub mobile-sub-dropdown`}
                            key={`nav-dropdown-custom-1`}
                            >
                              <NavDropdown.Item 
                                href={`${process.env.REACT_APP_MAIN_SITE_URL}/premium-programme`} 
                                className={`mobile-premium-programme`}
                                key={`nav-dropdown-sub-custom-1`}
                                >
                                  <img src={premium_btn} alt="premium-btn"/>
                              </NavDropdown.Item>
                              <NavDropdown.Item
                                href={`${process.env.REACT_APP_MAIN_SITE_URL}/premium-plus-programme`} 
                                className={`mobile-premium-programme-plus`}
                                key={`nav-dropdown-sub-custom-2`}
                                >
                                  <img src={premium_plus_btn} alt="premium-plus-btn"/>
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                href="https://shop.bookdoc.com/"
                                className={`mobile-premium-marketplace`}
                                key={`nav-dropdown-sub-custom-3`}
                                >
                                  <div className="mobile-marketplace-title">Explore Our Marketplace!</div>
                                  <img src={marketplace_btn} alt="marketplace-btn"/>
                                </NavDropdown.Item>
                            </NavDropdown>
                        </NavDropdown>
                      )
                    }
                    else if(n.subs && n.subs.length > 0){
                      return (
                        <NavDropdown title={<span className="nav-title">{n.title} <i className="fa fa fa-chevron-down icon-rotates icon-rotates-180" aria-hidden="true"></i></span>}  
                        className={`collasible-nav-dropdown ${([n.path].includes('/services') && !['/search-book/expert-column'].includes(window.location.pathname)) ? "active" : ""}`}
                        key={`nav-dropdown-${i}`}
                        >
                          {n.subs.map((s, ind) => {
                            return <NavDropdown.Item 
                            href={s.title === 'Marketplace' ? s.path : `${process.env.REACT_APP_MAIN_SITE_URL}${s.path}`} 
                            key={`nav-dropdown-item-${ind}`}
                            className={`${(s.path.includes('/search-book') && !['/search-book/expert-column'].includes(window.location.pathname)) ? 'active' : ''}`}
                            >
                              {s.title}
                            </NavDropdown.Item>;
                          })}
                        </NavDropdown>
                      )
                    }else{
                      return (
                        <div className="nav-item" key={`nav-item-${i}`}>
                          <Nav.Link href={`${process.env.REACT_APP_MAIN_SITE_URL}${n.path}`} className={`${[n.path].includes(window.location.pathname) ? "active" : ""}`}>{n.title}</Nav.Link>
                        </div>
                      )
                    }
                  })}

                  {(() => {
                    if(userService.getUser()){
                    return (
                        <NavDropdown title={<span className="nav-title">{userService.getUser().first_name} <i className="fa fa-plus icon-rotates" aria-hidden="true"></i></span>} id="more-dropdown">
                          <NavDropdown.Item href='/search-book/upcoming-appointment'>Upcoming Appointments</NavDropdown.Item>
                          <NavDropdown.Item href='/search-book/past-appointment'>Past Appointments</NavDropdown.Item>
                          <NavDropdown.Item href='/search-book/favourites'>Favourites</NavDropdown.Item>
                          <NavDropdown.Item href="/search-book/settings">Settings</NavDropdown.Item>
                          <NavDropdown.Item href="#" onClick={this.logout}>Sign out</NavDropdown.Item>
                        </NavDropdown>
                    );
                    }else{
                      return <div className="nav-item"><button type="button" className="btn btn-danger login-btn" onClick={() => this.handleSignInModal(true)}><span className="sign-in-text">Sign In</span></button></div>;
                    }
                  })()}

                  <div className="mobile-nav-contacts">
                    <a href="mailto:care@bookdoc.com" className="top-banner-email top-banner-contacts-item">
                      <i className="fa fa-envelope envelope-icon" aria-hidden="true"></i>care@bookdoc.com
                    </a>
                    <a href="tel:1300-88-2362" className="top-banner-phone top-banner-contacts-item">
                      <i className="fa fa-phone phone-icon" aria-hidden="true"></i>1300-88-2362
                    </a>
                    <a href="http://wa.me/60126442362" className="top-banner-whatsapp top-banner-contacts-item">
                      <i className="fa fa-whatsapp" aria-hidden="true"></i>WhatsApp Chat Only
                    </a>
                  </div>
                </Nav>
              </div>
            </Navbar.Collapse>
          </Navbar>

          <React.Fragment>
            <SignInModal showSignInModal={this.state.showSignInModal} handleSignInModal={this.handleSignInModal} handleSwitchSignUpModal={this.handleSwitchSignUpModal} handleSwitchChangePwModal={this.handleSwitchChangePwModal}/>
            <SignUpModal showSignUpModal={this.state.showSignUpModal} handleSignUpModal={this.handleSignUpModal} handleSwitchSignInModal={this.handleSwitchSignInModal}/>
            <ChangePwModal showChangePwModal={this.state.showChangePwModal} handleChangePwModal={this.handleChangePwModal} handleSwitchChangePwModal={this.handleSwitchChangePwModal}/>
          </React.Fragment>

        </div>
    )};
}

export { Navigation };
